import { createHead } from '@unhead/vue/client'

export const head = createHead()
